/* eslint-disable react/prop-types */
import { LayerItem } from 'components/minute/controls/LayerPanel/LayerItem';
import 'components/minute/controls/LayerPanel/LayerPanel.css';
import { LayerTreeNode, useLayerPanel } from 'components/minute/controls/LayerPanel/useLayerPanel';
import { DndProviderWrapper } from 'elements/functional/DndProviderWrapper';
import { Tree } from 'react-arborist';
import styled from 'styled-components/macro';

export const LayerPanel = () => {
    const layerPanel = useLayerPanel();

    return (
        <S_LayerPanel ref={layerPanel.containerRef}>
            <S_DNDProviderWrapper>
                <S_Tree
                    ref={layerPanel.treeRef}
                    data={layerPanel.treeData}
                    rowHeight={35}
                    width={250}
                    height={layerPanel.height}
                    // Do not render any preview
                    renderDragPreview={() => <></>}
                    rowClassName={'treeitem'}
                    disableEdit={false}
                    onSelect={layerPanel.onSelect}
                    onMove={layerPanel.onMove}
                >
                    {(props) => (
                        <>
                            <div
                                style={props.style}
                                ref={props.dragHandle}
                                onKeyDown={layerPanel.itemOnKeyDown}
                                onClick={(e) => layerPanel.itemOnClick(e, props.node.data.id)}
                            >
                                <LayerItem
                                    key={props.node.data.id}
                                    markerId={props.node.data.id}
                                    odd={props.node.data.index % 2 === 1}
                                />
                            </div>
                        </>
                    )}
                </S_Tree>
            </S_DNDProviderWrapper>
        </S_LayerPanel>
    );
};

const S_LayerPanel = styled.div`
    height: 340px;
    display: flex;
    border-radius: 0 0 7px 7px;
    background: #efefef;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
`;

const S_DNDProviderWrapper = styled(DndProviderWrapper)`
    height: 100%;
    width: 100%;
    display: flex;
`;

const S_Tree = styled<typeof Tree<LayerTreeNode>>(Tree)`
    height: 100%;
    width: 100%;
    display: flex;
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
        width: 15px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 0px;
    }
    &::-webkit-scrollbar-track {
        background-color: rgba(white, 0.5);
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c7cbd1;
        border-radius: 0px;
        // border: 1px solid white;
    }
`;
